/* global $ */
const heavyDrinksFirstHour = 3;
const avgDrinksFirstHour = 2;
const lightDrinksFirstHour = 1;
const heavyDrinksSubsHour = 1.5;
const avgDrinksSubsHour = 1;
const lightDrinksSubsHour = 0.5;
const beersPerUnit = 1;
const winePerUnit = 5;
const liquorPerUnit = 20;

function calculateTotalDrinks(partyDuration, lightDrinkers, avgDrinkers, heavyDrinkers) {
  // first calculate first hour
  let totalDrinks =
    heavyDrinksFirstHour * heavyDrinkers +
    avgDrinksFirstHour * avgDrinkers +
    lightDrinksFirstHour * lightDrinkers;
  if (partyDuration > 1) {
    const numSubsequentHourDrinks =
      heavyDrinksSubsHour * heavyDrinkers +
      avgDrinksSubsHour * avgDrinkers +
      lightDrinksSubsHour * lightDrinkers;
    totalDrinks += numSubsequentHourDrinks * (partyDuration - 1);
  }
  return totalDrinks;
}

function doCalculate() {
  let lightDrinkers = parseInt($('#numLightDrinkers').val(), 10);
  let averageDrinkers = parseInt($('#numAverageDrinkers').val(), 10);
  let heavyDrinkers = parseInt($('#numHeavyDrinkers').val(), 10);
  let duration = parseInt($('#durationHours').val(), 10);

  lightDrinkers = Number.isNaN(lightDrinkers) ? 0 : lightDrinkers;
  averageDrinkers = Number.isNaN(averageDrinkers) ? 0 : averageDrinkers;
  heavyDrinkers = Number.isNaN(heavyDrinkers) ? 0 : heavyDrinkers;
  duration = Number.isNaN(duration) ? 0 : duration;

  const beerSelected = $('#isBeerServed').is(':checked');
  const wineSelected = $('#isWineServed').is(':checked');
  const liquorSelected = $('#isLiquorServed').is(':checked');
  const totalDrinks = calculateTotalDrinks(duration, lightDrinkers, averageDrinkers, heavyDrinkers);
  let totalTypes = 0;
  if (beerSelected) {
    totalTypes++;
  }
  if (wineSelected) {
    totalTypes++;
  }
  if (liquorSelected) {
    totalTypes++;
  }
  if (totalTypes === 0) {
    return;
  }

  const totalPerType = totalDrinks / totalTypes;

  $('.row.needed').show();

  const drinkin = $('#drinkin').empty();

  if (beerSelected) {
    let beer = Math.ceil(totalPerType / beersPerUnit);
    beer = Number.isNaN(beer) ? 0 : beer;
    let plural = '';
    if (beer > 1) {
      plural = 's';
    }
    $(
      `<div class="section"><span class="calc__count header1">${beer}</span><p class="paragraph2">Bottle${plural}/Can${plural} of Beer</p></div>`
    ).appendTo(drinkin);
  } else {
    $(
      `<div class="section"><span class="calc__count header1">0</span><p class="paragraph2">Bottles/Cans of Beer</p></div>`
    ).appendTo(drinkin);
  }

  if (wineSelected) {
    let wine = Math.ceil(totalPerType / winePerUnit);
    wine = Number.isNaN(wine) ? 0 : wine;
    let plural = '';
    if (wine > 1) {
      plural = 's';
    }
    $(
      `<div class="section"><span class="calc__count header1">${wine}</span><p class="paragraph2">Bottle${plural} of Wine (750 ml)</p></div>`
    ).appendTo(drinkin);
  } else {
    $(
      `<div class="section"><span class="calc__count header1">0</span><p class="paragraph2">Bottles of Wine (750 ml)</p></div>`
    ).appendTo(drinkin);
  }

  if (liquorSelected) {
    let liquor = Math.ceil(totalPerType / liquorPerUnit);
    liquor = Number.isNaN(liquor) ? 0 : liquor;
    let plural = '';
    if (liquor > 1) {
      plural = 's';
    }
    $(
      `<div class="section"><span class="calc__count header1">${liquor}</span><p class="paragraph2">Bottle${plural} of Liquor (1 liter)</p></div>`
    ).appendTo(drinkin);
  } else {
    $(
      `<div class="section"><span class="calc__count header1">0</span><p class="paragraph2">Bottles of Liquor (1 liter)</p></div>`
    ).appendTo(drinkin);
  }
}

function checkErrors() {
  const errors = $('#error_box');
  errors.empty();
  errors.hide();

  let lightDrinkers = parseInt($('#numLightDrinkers').val(), 10);
  let averageDrinkers = parseInt($('#numAverageDrinkers').val(), 10);
  let heavyDrinkers = parseInt($('#numHeavyDrinkers').val(), 10);

  lightDrinkers = Number.isNaN(lightDrinkers) ? 0 : lightDrinkers;
  averageDrinkers = Number.isNaN(averageDrinkers) ? 0 : averageDrinkers;
  heavyDrinkers = Number.isNaN(heavyDrinkers) ? 0 : heavyDrinkers;

  if (lightDrinkers <= 0 && averageDrinkers <= 0 && heavyDrinkers <= 0) {
    $(`<p>Please enter at least one guest</p>`).appendTo(errors);
  }

  let duration = parseInt($('#durationHours').val(), 10);
  duration = Number.isNaN(duration) ? 0 : duration;
  if (duration < 1) {
    $(`<p>Please enter length of party</p>`).appendTo(errors);
  }

  const beerSelected = $('#isBeerServed').is(':checked');
  const wineSelected = $('#isWineServed').is(':checked');
  const liquorSelected = $('#isLiquorServed').is(':checked');
  if (!beerSelected && !wineSelected && !liquorSelected) {
    $(`<p>Please select at least one type of alcohol</p>`).appendTo(errors);
  }

  if (errors.html().length > 0) {
    errors.show();
  } else {
    doCalculate();
  }
}

$(document).ready(() => {
  checkErrors();
  $('#drink').on('change keyup', () => {
    checkErrors();
  });
});
